import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { FinancialKnowledge } from '@app/forms/subscription/definition/interface/subscription';
import FormGroupArray from '../../services/FormGroupArray';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: FinancialKnowledge & { riskProfil: any }, option) {
    let options: AbstractControlOptions = {};
    return this.formBuilder.group(
      {
        ownerId: [entity.ownerId],
        userFirstName: [entity.userFirstName],
        userLastName: [entity.userLastName],
        riskProfil: this.formBuilder.group({
          income: [entity?.riskProfil?.income || null, Validators.required],
          patrimonyValue: [
            entity?.riskProfil?.patrimonyValue || null,
            Validators.required,
          ],
        }),
      },
      options,
    );
  }
  generate(entity: FinancialKnowledge[], option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
    });
  }
  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }

  extract() {
    return this.form.value.owners;
  }
}
